import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTriggersRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastTriggersRoute() {
  const { broadcastId } = Route.useParams();
  return <BroadcastTriggersRouteView broadcastId={broadcastId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/broadcasts/',
)({
  component: BroadcastTriggersRoute,
});
